import type { DesignTheme } from '../hooks'

import type { DesignInfo } from './designs.types'

/** The admin's visual themes (ADR-056, ADR-068), in picker order. */
export const DESIGNS: DesignInfo[] = [
  {
    id: 'gxlabs',
    swatch: 'linear-gradient(160deg, #000000, #1a1a1a)',
    dots: ['#00bcd4', '#ffffff', '#666666'],
    vivid: false,
  },
  {
    id: 'apple',
    swatch: 'linear-gradient(160deg, #f5f5f7, #e8e8ed)',
    dots: ['#0071e3', '#1d1d1f', '#86868b'],
    vivid: false,
  },
  {
    id: 'aurora',
    swatch: 'linear-gradient(165deg, #2e1065, #5b21b6 55%, #86198f)',
    dots: ['#a78bfa', '#f0abfc', '#67e8f9'],
    vivid: true,
  },
  {
    id: 'sunset',
    swatch: 'linear-gradient(170deg, #7c2d12, #9a3412 45%, #9f1239)',
    dots: ['#fb923c', '#fda4af', '#fde68a'],
    vivid: true,
  },
  {
    id: 'lagoon',
    swatch: 'linear-gradient(170deg, #134e4a, #115e59 50%, #155e75)',
    dots: ['#5eead4', '#6ee7b7', '#7dd3fc'],
    vivid: true,
  },
  {
    id: 'neon',
    swatch: 'linear-gradient(175deg, #0b0a14, #1d0b2e 60%, #2a0a3a)',
    dots: ['#e879f9', '#22d3ee', '#a3e635'],
    vivid: true,
  },
]

const byId = new Map(DESIGNS.map((d) => [d.id, d]))

/**
 * Appearance of the dark chrome bands (sidebar, login band): GXLabs and the
 * colourful themes keep them dark with white ink; Apple follows light/dark.
 */
export const bandTheme = (design: DesignTheme, resolved: 'light' | 'dark') =>
  design === 'apple' ? resolved : 'dark'

/** Appearance of the login form: GXLabs stays light, the others follow light/dark. */
export const formTheme = (design: DesignTheme, resolved: 'light' | 'dark') =>
  design === 'gxlabs' ? 'light' : resolved

export const isDesign = (v: unknown): v is DesignTheme =>
  typeof v === 'string' && byId.has(v as DesignTheme)
